export default __webpack_public_path__ + "static/video-coming-soon-53a8f5e8735aa0148e5f5bbbf32a12bd.png";